/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const AccordionFragment = {
  Accordion: gql`
    fragment AccordionQuery on accordion_Entry {
      accordionDisplayType
      accordionItems {
        ... on accordionItemsBlock_Entry {
          itemDescription {
            html
          }
          itemTitle {
            html
          }
          showDescription
          accordionImage {
            url
            ... on images_Asset {
              altText
            }
          }
          accordionSectionTitle {
            ... on accordionSectionTitle_Entry {
              sectionTitle
            }
          }
        }
      }
      accordionLeftContent
      accordionRightContent
      accordionTitle
      buttonLabel
      buttonLink
      buttonLinkNewTab
      buttonLinkNofollow
      buttonType
      buttonCtaTag
      linebreak_mainContent
      styles
      typeHandle
    }
  `,
};
